export default __webpack_public_path__ + "static/siu-786e8da573db86a1a5ebba860192d117.jpg";